import { DIC } from "@/const/dic";
export const payConfigOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "300",
  labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "商户号",
      prop: "partner",
      type: "input",
    },
    {
      label: "appId",
      prop: "appId",
      type: "input",
    },
    {
      label: "公钥",
      prop: "publicKey",
      type: "input",
    },
    {
      label: "私钥",
      prop: "privateKey",
      type: "input",
    },
    {
      label: "回调地址",
      prop: "notifyUrl",
      type: "input",
    },
    {
      label: "支付类型",
      prop: "payType",
      type: "select",
      dicData: [
        {
          label: "微信",
          value: "wxPay",
        },{
          label: "支付宝",
          value: "aliPay",
        }
      ]
    },
    {
      label: "消息类型",
      prop: "msgType",
      type: "select",
      dicData: [
        {
          label: "TEXT",
          value: "text",
        },
        {
          label: "JSON",
          value: "json",
        },
        {
          label: "XML",
          value: "xml",
        }
      ]
    },
    {
      label: "appSecret",
      prop: "appSecret",
      type: "input",
    },
    {
      label: "退款回调",
      prop: "returnUrl",
      type: "input",
    },
    {
      label: "证书",
      prop: "certificate",
      solt: true,
      formsolt: true,
    },
    {
      label: "客户端类型",
      prop: "clientType",
      type: "select",
      dicData: DIC.CLIENT_TYPE,
    },
  ],
};
